<template>
  <!-- Projects Section -->
  <section class="projects-section" id="projects">
    <div class="projects-header">
      <h2 class="projects-title">{{ locale === 'tr' ? 'Projelerimiz' : 'Projects' }}</h2>
    </div>
    <!-- Debug info -->

    
    <div class="projects-grid">
      <div
        class="project-card project-card-bordered"
        v-for="(project, index) in featuredProjects"
        :key="project.id"
        ref="projectCards"
        :data-index="index"
        :data-id="project.id"
      >
        <img 
          class="project-image" 
          :src="project.image"
          :alt="project.title"
          loading="lazy"
          @error="(e) => handleImageError(e, 'project')"
          @load="(e) => { imageCache.set(e.target.src, 'success'); loadingImages.delete(e.target.src) }"
        />
        <div class="project-content">
          <h3>{{ project.title }}</h3>
          <p>{{ project.description }}</p>
          <div class="project-meta">
            <span class="project-capacity" v-if="project.capacity">⚡ {{ project.capacity }}</span>
            <span class="project-location" v-if="project.location">📍 {{ project.location }}</span>
          </div>
          <!-- Hover overlay with details button -->
          <div class="project-hover-overlay" @click="goToProjectDetail(project.id)">
            <button class="project-details-btn">
              {{ locale === 'tr' ? 'Detayları Gör' : 'View Details' }}
            </button>
          </div>
        </div>
      </div>
    </div>
    <div class="projects-footer">
      <button class="all-projects-btn" @click="goToAllProjects">
        <span>{{ locale === 'tr' ? 'Tüm Projelerimiz' : 'All Our Projects' }}</span>
        <i class="fas fa-arrow-right"></i>
      </button>
    </div>

  </section>
</template>

<script setup>
import { computed, onMounted, nextTick, watch } from 'vue'
import { useProjects } from '@/composables/useProjects'

// Props
const props = defineProps({
  locale: {
    type: String,
    default: 'tr'
  }
})

// Computed locale
const locale = computed(() => props.locale)

// Composable kullanımı
const { 
  featuredProjects, 
  imageCache, 
  loadingImages,
  handleImageError,
  goToProjectDetail,
  goToAllProjects
} = useProjects(locale)

// Animation for project cards
const animateProjectCards = () => {
  nextTick(() => {
    const cards = document.querySelectorAll('.project-card')
    cards.forEach((card, index) => {
      setTimeout(() => {
        card.classList.add('show-card')
      }, index * 100)
    })
  })
}

// Watch for data changes and animate
watch(featuredProjects, () => {
  if (featuredProjects.value.length > 0) {
    animateProjectCards()
  }
}, { immediate: true })

onMounted(() => {
  animateProjectCards()
})
</script>